import { render, staticRenderFns } from "./AddOfferItem.vue?vue&type=template&id=783d3bd6&scoped=true"
import script from "./AddOfferItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOfferItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddOfferItem.vue?vue&type=style&index=0&id=783d3bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d3bd6",
  null
  
)

export default component.exports